// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IPointF {
	isEmpty: boolean;

	x: number;

	y: number;

	$type?: string | undefined;
}
export class PointF {
	constructor(data?: IPointF) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	isEmpty: boolean = false;

	x: number = 0;

	y: number = 0;

	static $type: string = "Shared.Geometry.PointF, ";
	$type?: string | undefined = PointF.$type;
}

